export default function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/shuffle.js
// module id = ZgKu
// module chunks = 0